import type { ApiConfiguration, AuthConfiguration } from "@/types/auth";

export const useApiConfig = () => {
    const config = useRuntimeConfig();

    const api: ApiConfiguration = {
        baseUrl: config.public.apiBaseUrl,
        publicUrl: config.public.apiPublicUrl,
    };

    const v1api: ApiConfiguration = {
        baseUrl: config.public.apiV1BaseUrl,
        publicUrl: config.public.apiPublicUrl,
    };

    const auth: AuthConfiguration = {
        tokenKey: 'user_token',
        endpoints: {
            login: 'login',
            logout: 'logout',
            user: 'user'
        },
        redirects: {
            loginPage: '/login',
            logoutPage: '/logout',
            userIndexPage: '/'
        }
    };

    return { api, v1api, auth };
};
